package dk.rheasoft.csaware.api

@Suppress("EnumEntryName")
enum class LayoutDirection {
    horizontal, vertical;

    fun isHorizontal() = this == horizontal
    fun isVertical() = this == vertical
}
